<!-- 我的页面 -->
<template>
  <div v-if="leavePopShow">
    <div class="backmodal" >
      <div class="backflex">
        <div class="b_content">
           <div class="b_txt_1">{{msg_1}}</div>
           <div class="b_txt_2">{{msg_2}}</div>
           <div class="b_btn_1 b_btn" @click="ContinuePay">
              <span>{{btn_msg_1}}</span>

              <div class="ivu-icon ios-arrow-forward">
                  <Icon class="nav_back"
                style="font-size:1.8rem;"
                type="ios-arrow-forward"
              />
             </div>
           </div>
           <div class="b_btn_2 b_btn" @click="CloseBackPop">
             <span>{{btn_msg_2}}</span>
               <div class="ivu-icon ios-arrow-back">
                  <Icon class="nav_back"
                style="font-size:1.8rem;"
                type="ios-arrow-back"
              />
             </div>
           </div>
           <div class="b_close" @click="CloseBackPop">
             <img src="@/assets/image/icon/close.svg"/>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {

    }
  },
  props:{
    leavePopShow:{
      type:Boolean,
      default:false,
    },
    msg_1:{
      type:String,
      default:""
    },
    msg_2:{
      type:String,
      default:""
    },
    msg_3:{
      type:String,
      default:""
    },
    btn_msg_1:{
      type:String,
      default:""
    },
    btn_msg_2:{
      type:String,
      default:""
    },

  },
  // 监听属性 类似于data概念
  computed: {

  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
   CloseBackPop(){
     this.$emit('cancelPop');
   },
   ContinuePay(){
     this.$emit('confirmPop')
   }
  }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
.backmodal{
  width:100%;
  height: 100%;
  position:fixed ;
  top: 0;
  left: 0;
  background: rgba(104, 104, 104, 0.6);
  z-index: 999;
.backflex{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .b_content{
      width: 40rem;
      padding:5rem 2rem 4rem;
      background:#fff;
      position: relative;
      text-align: left;
      .b_txt_1{
        font-weight: 400;
        color: #5C5D5F;
        font-size: 1.2rem;
        margin-bottom: 1.6rem;
      }
      .b_txt_2{
        font-weight: 400;
        color: #5C5D5F;
        font-size: 1.2rem;
        margin-bottom: 5.7rem;
      }
      .b_btn{
        cursor: pointer;
        width: 36rem;
        height: 3.6rem;
        display: flex;
        align-items: center;
        bacfont-weight: 500;
        font-size: 1.2rem;
        padding: 0 2rem;
      }
      .b_btn_1{
        background: #5C5D5F;
        color: #FFFFFF;
        margin-bottom: 1rem;
        .ivu-icon{
          margin-left: auto;
        }
      }
      .b_btn_2{
        background: #FFFFFF;
        border: 0.1rem solid #5C5D5F;
        font-weight: 500;
        color: #5C5D5F;
        font-size: 1.2rem;
        .ivu-icon{
          margin-left: auto;
          color: #000;
        }
      }
      .b_close{
        cursor: pointer;
        width: 1.3rem;
        height: 1.3rem;
        position: absolute;
        top: 2.8rem;
        right: 2.8rem;
        img{
          width:100%;
        }
      }
    }
}


}

</style>



// WEBPACK FOOTER //
// src/components/common/LeaveTipPop.vue